import { NgModule } from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSliderModule} from '@angular/material/slider';
import {MatToolbarModule} from '@angular/material/toolbar';
import { CoreModule } from '../core/core.module';
import { ArrowDropComponent } from './components/arrow-drop.component';
import { CloseComponent } from './components/close.component';
import { FbDropdownListComponent } from './components/dropdown-list/dropdown-list.component';
import { InfoIconComponent } from './components/info-icon/info-icon.component';
import { InfoIconModule } from './components/info-icon/info-icon.module';
import { LocalizationComponent } from './components/localization.component';
import { FbaMenuComponent } from './components/menu.component';
import { PreloaderDotsComponent } from './components/preloader-dots.component';
import { TickComponent } from './components/tick.component';
import { ValidateMessageComponent } from './components/validate-messages.component';
import { AppendToDirective } from './directives/append-to.directive';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { LinkDirective } from './directives/link.directive';
import { PluralPipe } from './pipes/plural.pipe';
import { ValuesPipe } from './pipes/values.pipe';
import { MatLineModule } from '@angular/material/core';
import { SharedActions } from './actions/shared-actions.service';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ButtonComponent } from './components/button/button.component';
import { InputTextComponent } from './components/input-text/input-text.component';
import { FacebookService } from './services/facebook.service';

@NgModule({
  imports: [
    CoreModule,
    InfoIconModule,
    MatMenuModule,
    MatSidenavModule,
    MatButtonModule,
    MatListModule,
    MatIconModule,
    MatLineModule,
    MatToolbarModule,
    MatCardModule,
    MatSliderModule,
    AngularSvgIconModule
  ],
  declarations: [
    AppendToDirective,
    ClickOutsideDirective,
    LinkDirective,
    LocalizationComponent,
    CloseComponent,
    FbDropdownListComponent,
    TickComponent,
    ValuesPipe,
    PluralPipe,
    ValidateMessageComponent,
    FbaMenuComponent,
    ArrowDropComponent,
    PreloaderDotsComponent,
    InputTextComponent,
    ButtonComponent
  ],
  exports: [
    CoreModule,
    InfoIconModule,
    MatMenuModule,
    MatSidenavModule,
    MatButtonModule,
    MatListModule,
    MatIconModule,
    MatLineModule,
    MatToolbarModule,
    MatCardModule,
    MatSliderModule,
    AngularSvgIconModule,
    AppendToDirective,
    ClickOutsideDirective,
    LinkDirective,
    LocalizationComponent,
    CloseComponent,
    FbDropdownListComponent,
    TickComponent,
    InfoIconComponent,
    ValuesPipe,
    ValidateMessageComponent,
    PreloaderDotsComponent,
    ArrowDropComponent,
    FbaMenuComponent,
    ButtonComponent,
    InputTextComponent
  ],
  providers: [
    FacebookService,
    SharedActions
  ]
})
export class SharedModule { }
